import { Product } from '../types/product'

export const season = 'Autumn / Winter 2026'

export const palette = [
  { name: 'Transformative Teal', hex: '#12545C', note: 'A deep, still blue-green.' },
  { name: 'Wax Paper / Cloud Dancer', hex: '#EDE7DA', note: 'Warm undyed off-white.' },
  { name: 'Cocoa Powder / Chocolate Fondant', hex: '#4A3229', note: 'Dark, matte cocoa.' },
]

const womensSizes = ['XS', 'S', 'M', 'L', 'XL']
const mensSizes = ['S', 'M', 'L', 'XL', 'XXL']

export const products: Product[] = [
  {
    id: 'set-teal',
    name: 'Modal Night Set',
    category: 'night-suits',
    price: 5000,
    colour: 'Transformative Teal',
    colourHex: '#12545C',
    composition: '100% modal fibre, knit',
    detail: 'Crew-neck knit tee with a matching trouser. No collar, no placket, no pockets.',
    images: {
      women:
        'https://cdn.magicpatterns.com/patterns/generated-images/08904030-0a5b-4567-bc71-54a7704c5aa8.jpg',
      men: 'https://cdn.magicpatterns.com/patterns/generated-images/876ed83b-66d9-481e-9045-099e8403355d.jpg',
    },
    sizes: { women: womensSizes, men: mensSizes },
  },
  {
    id: 'set-waxpaper',
    name: 'Modal Night Set',
    category: 'night-suits',
    price: 5000,
    colour: 'Wax Paper / Cloud Dancer',
    colourHex: '#EDE7DA',
    composition: '100% modal fibre, knit',
    detail: 'Crew-neck knit tee with a soft elastic-waist trouser. Undyed base cloth.',
    images: {
      women:
        'https://cdn.magicpatterns.com/patterns/generated-images/ff4a35e0-59e2-4369-9a7a-98a70de0e9af.jpg',
      men: 'https://cdn.magicpatterns.com/patterns/generated-images/1d6cfd30-7174-455b-99c0-4412ffa9bcd8.jpg',
    },
    sizes: { women: womensSizes, men: mensSizes },
  },
  {
    id: 'set-cocoa',
    name: 'Modal Night Set',
    category: 'night-suits',
    price: 5000,
    colour: 'Cocoa Powder / Chocolate Fondant',
    colourHex: '#4A3229',
    composition: '100% modal fibre, knit',
    detail: 'Crew-neck knit tee with a matching trouser. Clean hem, no pockets.',
    images: {
      women:
        'https://cdn.magicpatterns.com/patterns/generated-images/fbbe5bd6-00e4-4e39-a564-3a9627b57d3a.jpg',
      men: 'https://cdn.magicpatterns.com/patterns/generated-images/db8db7bb-5411-499d-8a48-795487d58423.jpg',
    },
    sizes: { women: womensSizes, men: mensSizes },
  },
  {
    id: 'tee-teal',
    name: 'Modal Tee',
    category: 't-shirts',
    price: 3000,
    colour: 'Transformative Teal',
    colourHex: '#12545C',
    composition: '100% modal fibre, knit',
    detail: 'Narrow ribbed crew, clean side seams, fluid matte drape.',
    images: {
      women:
        'https://cdn.magicpatterns.com/patterns/generated-images/35c45dd6-5f92-4e87-b97d-a8605b8f59df.jpg',
      men: 'https://cdn.magicpatterns.com/patterns/generated-images/101f4d35-7f76-4fb3-b0b4-0df6cfdb4ee1.jpg',
    },
    sizes: { women: womensSizes, men: mensSizes },
  },
  {
    id: 'tee-waxpaper',
    name: 'Modal Tee',
    category: 't-shirts',
    price: 3000,
    colour: 'Wax Paper / Cloud Dancer',
    colourHex: '#EDE7DA',
    composition: '100% modal fibre, knit',
    detail: 'Narrow ribbed crew, undyed base cloth, softens with every wash.',
    images: {
      women:
        'https://cdn.magicpatterns.com/patterns/generated-images/f87740d4-36ff-4e4b-8f1e-fb48ebbd7625.jpg',
      men: 'https://cdn.magicpatterns.com/patterns/generated-images/6d457d1d-0720-4863-85b8-32fb7b95a9c3.jpg',
    },
    sizes: { women: womensSizes, men: mensSizes },
  },
  {
    id: 'tee-cocoa',
    name: 'Modal Tee',
    category: 't-shirts',
    price: 3000,
    colour: 'Cocoa Powder / Chocolate Fondant',
    colourHex: '#4A3229',
    composition: '100% modal fibre, knit',
    detail: 'Narrow ribbed crew, garment dyed in Tiruppur, holds its depth.',
    images: {
      women:
        'https://cdn.magicpatterns.com/patterns/generated-images/c7fbfab0-326e-4193-96a0-ab4dd2aef8e9.jpg',
      men: 'https://cdn.magicpatterns.com/patterns/generated-images/24f89d95-55ee-4cb4-b623-3a68f5768f07.jpg',
    },
    sizes: { women: womensSizes, men: mensSizes },
  },
]

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/fb4ad7f3-41ce-4597-aff9-0aed80995140.jpg'

export const materialImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/5ddfa47a-223e-4992-b7e7-a495a6308f33.jpg'

export const editorialImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/acc5bde0-8df2-48c0-b437-bca1062887f8.jpg'
